import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "vw-100 vh-100 bg-light position-relative" };
const _hoisted_2 = {
    id: "start",
    class: "position-absolute top-50 start-50 translate-middle"
};
const _hoisted_3 = { class: "bg-white p-5 shadow rounded" };
const _hoisted_4 = { class: "text-center mt-3" };
const _hoisted_5 = ["href"];
const _hoisted_6 = ["href"];
const _hoisted_7 = ["href"];
import { responseMessages } from '@/Composables/responseMessages';
import LoginForm from '@/Shared/LoginForm.vue';
import { Head } from '@inertiajs/vue3';
import Toast from 'primevue/toast';
export default /*@__PURE__*/ _defineComponent({
    __name: 'Login',
    props: {
        canResetPassword: Boolean,
        status: String,
    },
    setup(__props) {
        let { showErrorSwal } = responseMessages();
        const props = __props;
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createVNode(_unref(Head), { title: "Login" }),
                _createElementVNode("div", _hoisted_1, [
                    _createElementVNode("div", _hoisted_2, [
                        _cache[2] || (_cache[2] = _createElementVNode("div", { class: "mb-4 text-center" }, [
                            _createElementVNode("svg", {
                                xmlns: "http://www.w3.org/2000/svg",
                                height: "65",
                                fill: "currentColor",
                                class: "bi bi-gear-wide-connected",
                                viewBox: "0 0 16 16"
                            }, [
                                _createElementVNode("path", { d: "M7.068.727c.243-.97 1.62-.97 1.864 0l.071.286a.96.96 0 0 0 1.622.434l.205-.211c.695-.719 1.888-.03 1.613.931l-.08.284a.96.96 0 0 0 1.187 1.187l.283-.081c.96-.275 1.65.918.931 1.613l-.211.205a.96.96 0 0 0 .434 1.622l.286.071c.97.243.97 1.62 0 1.864l-.286.071a.96.96 0 0 0-.434 1.622l.211.205c.719.695.03 1.888-.931 1.613l-.284-.08a.96.96 0 0 0-1.187 1.187l.081.283c.275.96-.918 1.65-1.613.931l-.205-.211a.96.96 0 0 0-1.622.434l-.071.286c-.243.97-1.62.97-1.864 0l-.071-.286a.96.96 0 0 0-1.622-.434l-.205.211c-.695.719-1.888.03-1.613-.931l.08-.284a.96.96 0 0 0-1.186-1.187l-.284.081c-.96.275-1.65-.918-.931-1.613l.211-.205a.96.96 0 0 0-.434-1.622l-.286-.071c-.97-.243-.97-1.62 0-1.864l.286-.071a.96.96 0 0 0 .434-1.622l-.211-.205c-.719-.695-.03-1.888.931-1.613l.284.08a.96.96 0 0 0 1.187-1.186l-.081-.284c-.275-.96.918-1.65 1.613-.931l.205.211a.96.96 0 0 0 1.622-.434zM12.973 8.5H8.25l-2.834 3.779A4.998 4.998 0 0 0 12.973 8.5m0-1a4.998 4.998 0 0 0-7.557-3.779l2.834 3.78zM5.048 3.967l-.087.065zm-.431.355A4.98 4.98 0 0 0 3.002 8c0 1.455.622 2.765 1.615 3.678L7.375 8zm.344 7.646.087.065z" })
                            ])
                        ], -1)),
                        _createElementVNode("div", _hoisted_3, [
                            _createVNode(LoginForm, {
                                "can-reset-password": props.canResetPassword,
                                status: props.status
                            }, null, 8, ["can-reset-password", "status"])
                        ]),
                        _createElementVNode("div", _hoisted_4, [
                            _createElementVNode("a", {
                                href: _ctx.route('imprint'),
                                target: "_blank"
                            }, "Impressum", 8, _hoisted_5),
                            _cache[0] || (_cache[0] = _createTextVNode(" | ", -1)),
                            _createElementVNode("a", {
                                href: _ctx.route('privacy'),
                                target: "_blank"
                            }, "Datenschutzerklärung", 8, _hoisted_6),
                            _cache[1] || (_cache[1] = _createTextVNode(" | ", -1)),
                            _createElementVNode("a", {
                                href: _ctx.route('termsOfService'),
                                target: "_blank"
                            }, "Nutzungsbedingungen", 8, _hoisted_7)
                        ])
                    ])
                ]),
                _createVNode(_unref(Toast))
            ], 64));
        };
    }
});
